import { Aluno } from './aluno';
import { Contrato } from './contrato';
import { Diagnostico } from './diagnostico';
import { MetaAtendimento } from './meta-atendimento';
import { Programa } from './programa';
import { Projeto } from './projeto';
import { Solucoes } from './solucoes';

export class Atendimento {
	id: number;
	descDiagnostico: string;
	descSolucao: string;
	dataAtendimento: Date;
	solucoes: Solucoes;
	aluno: Aluno;
    diagnostico: Diagnostico;
	usuarioAlteracao: number;
	contrato: Contrato;
	programa: Programa;
	projeto: Projeto;
	metas: MetaAtendimento[];
}